'use client';

import { useRef } from 'react';
import { EmbeddedComponentRegion } from '@/components/region/embedded-component-region';
import type { ComponentWithComponentData } from '@/lib/page-designer/component-loader.server';
import { FOOTER_LINK_REGION_IDS } from '@/features/global-footer/constants';

type LinkColumnsProps = {
    globalFooter: Promise<ComponentWithComponentData | null>;
};

export const LinkColumns = ({ globalFooter }: LinkColumnsProps) => {
    const componentRef = useRef<Promise<ComponentWithComponentData | null> | undefined>(undefined);
    if (!componentRef.current) {
        componentRef.current = globalFooter;
    }

    const component = componentRef.current;

    return (
        <div data-slot="global-footer-link-columns" className="grid grid-cols-1 lg:grid-cols-5 lg:pt-8 gap-x-4">
            {FOOTER_LINK_REGION_IDS.map((regionId) => (
                <div key={regionId}>
                    <EmbeddedComponentRegion
                        component={component}
                        regionId={regionId}
                        fallbackElement={null}
                        errorElement={null}
                    />
                </div>
            ))}
        </div>
    );
};
